export default __webpack_public_path__ + "static/media/VERA.20f2f7bc.png";